import { createFileRoute } from "@tanstack/react-router";
import { RoundsScreen } from "@modules/rounds/views";
import { requireAnySurface } from "../-guards";

// /staff/rounds — both the administrator's AND the coordinator's landing screen (2026-09-13:
// `intake_operations` joined `SURFACE_HOME` alongside `round_configuration`). `RoundsScreen`
// itself reads the caller's own surfaces to decide which actions a card renders — an
// administrator gets create/edit/extend, a coordinator gets only "Voir les dossiers" — so sharing
// this route does not mean sharing every action on it.
export const Route = createFileRoute("/staff/rounds")({
  beforeLoad: ({ context, location }) =>
    requireAnySurface(
      context.queryClient,
      ["round_configuration", "intake_operations"],
      location.pathname
    ),
  staticData: { breadcrumb: ["nav.rounds", "breadcrumb.all-rounds"] },
  component: RoundsScreen,
});
